/**
 * 端末ローカルの暦日（docs/spec/progress-store.md §2）。toISOString() は UTC なので使わない。
 */

/** `YYYY-MM-DD`。 */
export type LocalDate = string;

const LOCAL_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
const DAY_MS = 86_400_000;

const pad2 = (n: number): string => String(n).padStart(2, '0');

/** Date を端末ローカルの暦日にする。 */
export function toLocalDate(d: Date): LocalDate {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function isLocalDate(s: unknown): s is LocalDate {
  if (typeof s !== 'string') return false;
  const m = LOCAL_DATE.exec(s);
  if (!m) return false;
  const t = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return utcToLocalDate(t) === s;
}

function toUtcMs(d: LocalDate): number {
  const m = LOCAL_DATE.exec(d);
  if (!m) throw new RangeError(`invalid LocalDate: ${d}`);
  return Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

function utcToLocalDate(ms: number): LocalDate {
  const d = new Date(ms);
  return `${String(d.getUTCFullYear()).padStart(4, '0')}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

/** 日単位の加減算（Date.UTC 上で行うので夏時間の影響を受けない）。 */
export function addDays(d: LocalDate, n: number): LocalDate {
  return utcToLocalDate(toUtcMs(d) + n * DAY_MS);
}

/** b - a の日数。 */
export function diffDays(a: LocalDate, b: LocalDate): number {
  return Math.round((toUtcMs(b) - toUtcMs(a)) / DAY_MS);
}

/** 週のキー = その週の月曜の LocalDate（月曜始まり）。 */
export function weekKey(d: LocalDate): LocalDate {
  const dow = new Date(toUtcMs(d)).getUTCDay(); // 0 = 日曜
  return addDays(d, -((dow + 6) % 7));
}

/** エクスポートのファイル名用 `YYYYMMDD`（端末ローカル。§6.1）。 */
export function compactLocalDate(d: Date): string {
  return toLocalDate(d).replaceAll('-', '');
}
